import React from 'react';

import { Modal } from 'src/components/common';
import { PeoControlledByConfigurationModalForm } from 'src/components/peo/PeoControlledByConfigurationModalForm';
import { useModalV2 } from 'src/hooks/shared';
import { ModalV2Props } from 'src/types/modalV2';

type PeoControlledByConfigurationModalProps = {
  peoId: string;
};

export const PeoControlledByConfigurationModal: React.FC<
  ModalV2Props<PeoControlledByConfigurationModalProps>
> = ({ id, peoId }) => {
  const { closeModal, switchClosability } = useModalV2();

  const handleCloseModal = React.useCallback(() => {
    closeModal(id);
  }, [closeModal, id]);

  return (
    <Modal
      title="Manage PEO hierarchy"
      maxWidth={550}
      headerPadding="32px 32px 8px 32px"
      dialogProps={{
        onClose: handleCloseModal,
        open: true,
      }}
    >
      <PeoControlledByConfigurationModalForm
        peoId={peoId}
        onCloseModal={handleCloseModal}
        switchClosability={switchClosability}
      />
    </Modal>
  );
};
